// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3FRCh","name":"ConsentHeader_name__YgYZS","birthday":"ConsentHeader_birthday__3AtK0","skeleton":"ConsentHeader_skeleton__b7Dwu"};